













































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {TransactionOperations} from '@/enums/TransactionOperations';
import TransactionsApi from '@/apis/TransactionsApi';
import TransactionLogResponseModel from '@/models/transactions/TransactionLogResponseModel';

@Component({
        name: 'TransactionLogs',
    },
)
export default class TransactionLogs extends ViewBase {
    @Prop({default: 0, required: true})
    public transactionId!: number;
    @Prop({default: 0, required: true})
    public bankAccountId!: number;
    @Prop({default: 0, required: true})
    public fundId!: number;

    public logs: TransactionLogResponseModel[] = [];
    public authorized: boolean = false;

    public headers = [
        {text: 'Change Date/Time', align: 'left', sortable: true, value: 'createdDateTimeUtc'},
        {text: 'Field', align: 'left', sortable: true, value: 'fieldName'},
        {text: 'Old Value', align: 'left', sortable: false, value: 'oldValue'},
        {text: 'New Value', align: 'left', sortable: false, value: 'newValue'},
        {text: 'Changed By', align: 'left', sortable: true, value: 'createdBy'},
    ];

    public get showLogs(): boolean {
        if ( !this.initializing && !this.initializationError ) {
            return true;
        }

        return false;
    }

    public async created() {
        if ( this.$store.state.selectedTransaction.authorizedOperations & TransactionOperations.VIEW_LOGS )
        {
            this.authorized = true;

            try {
                this.resetInitializationValues();

                const api = new TransactionsApi();
                this.logs = await api.getLogsAsync(this.bankAccountId, this.transactionId, this.$store.state.member.jwt);
            }
            catch ( err ) {
                await this.handleInitializationErrorAsync(err);
            }
            finally {
                this.initializing = false;
            }
        }
    }
}

